"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _useStyleToEmotionObject = _interopRequireDefault(require("../hooks/internal/useStyleToEmotionObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: [P3] Although this is for development purpose, prettify it
var ROOT_STYLE = {
  color: 'Red',
  margin: 0
};

var SayAlt = function SayAlt(_ref) {
  var speak = _ref.speak;
  var rootClassName = (0, _useStyleToEmotionObject.default)()(ROOT_STYLE) + '';
  return !!speak && /*#__PURE__*/_react.default.createElement("pre", {
    className: rootClassName
  }, speak);
};

SayAlt.defaultProps = {
  speak: ''
};
SayAlt.propTypes = {
  speak: _propTypes.default.string
};
var _default = SayAlt;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9BY3Rpdml0eS9TYXlBbHQuanMiXSwibmFtZXMiOlsiUk9PVF9TVFlMRSIsImNvbG9yIiwibWFyZ2luIiwiU2F5QWx0Iiwic3BlYWsiLCJyb290Q2xhc3NOYW1lIiwiZGVmYXVsdFByb3BzIiwicHJvcFR5cGVzIiwiUHJvcFR5cGVzIiwic3RyaW5nIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBQ0E7O0FBRUE7Ozs7QUFFQTtBQUNBLElBQU1BLFVBQVUsR0FBRztBQUNqQkMsRUFBQUEsS0FBSyxFQUFFLEtBRFU7QUFFakJDLEVBQUFBLE1BQU0sRUFBRTtBQUZTLENBQW5COztBQUtBLElBQU1DLE1BQU0sR0FBRyxTQUFUQSxNQUFTLE9BQWU7QUFBQSxNQUFaQyxLQUFZLFFBQVpBLEtBQVk7QUFDNUIsTUFBTUMsYUFBYSxHQUFHLHdDQUEwQkwsVUFBMUIsSUFBd0MsRUFBOUQ7QUFFQSxTQUFPLENBQUMsQ0FBQ0ksS0FBRixpQkFBVztBQUFLLElBQUEsU0FBUyxFQUFFQztBQUFoQixLQUFnQ0QsS0FBaEMsQ0FBbEI7QUFDRCxDQUpEOztBQU1BRCxNQUFNLENBQUNHLFlBQVAsR0FBc0I7QUFDcEJGLEVBQUFBLEtBQUssRUFBRTtBQURhLENBQXRCO0FBSUFELE1BQU0sQ0FBQ0ksU0FBUCxHQUFtQjtBQUNqQkgsRUFBQUEsS0FBSyxFQUFFSSxtQkFBVUM7QUFEQSxDQUFuQjtlQUllTixNIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHVzZVN0eWxlVG9FbW90aW9uT2JqZWN0IGZyb20gJy4uL2hvb2tzL2ludGVybmFsL3VzZVN0eWxlVG9FbW90aW9uT2JqZWN0JztcblxuLy8gVE9ETzogW1AzXSBBbHRob3VnaCB0aGlzIGlzIGZvciBkZXZlbG9wbWVudCBwdXJwb3NlLCBwcmV0dGlmeSBpdFxuY29uc3QgUk9PVF9TVFlMRSA9IHtcbiAgY29sb3I6ICdSZWQnLFxuICBtYXJnaW46IDBcbn07XG5cbmNvbnN0IFNheUFsdCA9ICh7IHNwZWFrIH0pID0+IHtcbiAgY29uc3Qgcm9vdENsYXNzTmFtZSA9IHVzZVN0eWxlVG9FbW90aW9uT2JqZWN0KCkoUk9PVF9TVFlMRSkgKyAnJztcblxuICByZXR1cm4gISFzcGVhayAmJiA8cHJlIGNsYXNzTmFtZT17cm9vdENsYXNzTmFtZX0+e3NwZWFrfTwvcHJlPjtcbn07XG5cblNheUFsdC5kZWZhdWx0UHJvcHMgPSB7XG4gIHNwZWFrOiAnJ1xufTtcblxuU2F5QWx0LnByb3BUeXBlcyA9IHtcbiAgc3BlYWs6IFByb3BUeXBlcy5zdHJpbmdcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFNheUFsdDtcbiJdfQ==